import { Scoreboard } from "./../../data";
import { ScoreboardTennisParser } from "./ScoreboardTennisParser";
import { eBranches } from "sb-resp-lib";
import { entities } from "sbtech-sports-data-api-client";

export class ScoreboardParser {
    private static _instance: ScoreboardParser;

    private constructor() { }

    public static get instance(): ScoreboardParser {
        if (!ScoreboardParser._instance) {
            ScoreboardParser._instance = new ScoreboardParser();
        }
        return ScoreboardParser._instance;
    }

    public parse(sportEvent: entities.SportEvent): Scoreboard | undefined {
        switch (Number(sportEvent.sportId)) {
            case eBranches.Tennis: return ScoreboardTennisParser.instance.parse(sportEvent);
        }

        return undefined;
    }
};